module.exports = __webpack_public_path__ + "img/junior-intermediate.bd706833.jpg";